let record = {
  queryRecordNet: {
    //分页查询录音（通话录音/会议录音）

    /***录音查询接口
    **/
    url: '/scooper-record/data/record/queryRecord',
    method: 'POST',
    requestParam: {
      token: '',
      recType: '',
      //录音类型 1：通话录音（调度&平台）2：会议录音
      id: '',
      //录音id
      businessId: '',
      //业务id
      meetId: '',
      //
      caller: '',
      callee: '',
      timeMin: '',
      //录音开始时间查询起始值
      timeMax: '',
      pageIndex: '',
      pageSize: ''
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        total: '',
        list: [{
          id: '',
          businessId: '',
          meetId: '',
          caller: '',
          callee: '',
          tmBegin: '',
          //开始时间
          tmEnd: '',
          //结束时间
          callLength: '',
          //录音长度
          recFile: '',
          //录音文件名
          recType: '',
          //录音类型(字段无效)
          recExt: '' //备注信息

        }]
      }
    }
  },
  queryCallRecordNet: {
    //获取通话录音录像
    url: '/scooper-record/data/call/queryCallRecords',
    method: 'GET',
    requestParam: {
      token: '',
      timeMin: '',
      timeMax: '',
      pageNumber: 1,
      fileType: 0,
      //0:录音，1：录像
      pageSize: 10
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        pageNumber: 1,
        pageSize: 10,
        total: 1884,
        list: []
      }
    }
  },
  queryMeetingRecordNet: {
    //获取会议录音录像
    url: '/scooper-record/data/meeting/queryMeetingRecords',
    method: 'GET',
    requestParam: {
      token: '',
      timeMin: '',
      timeMax: '',
      pageNumber: 1,
      pageSize: 10
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        pageNumber: 1,
        pageSize: 10,
        total: 1884,
        list: []
      }
    }
  },
  queryVideoNet: {
    //分页查询录像 (通话录像/会议录像)

    /***录像查询接口
    **/
    url: '/scooper-record/data/video/queryVideo',
    method: 'POST',
    requestParam: {
      token: '',
      recType: '',
      //录像类型 1：通话录像（调度&平台）2：会议录像
      id: '',
      //录像id
      businessId: '',
      //业务id
      meetId: '',
      //
      tel: '',
      timeMin: '',
      //录像开始时间查询起始值
      timeMax: '',
      pageIndex: '',
      pageSize: ''
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        total: '',
        list: [{
          id: '',
          businessId: '',
          meetId: '',
          tel: '',
          tmBegin: '',
          //开始时间
          tmEnd: '',
          //结束时间
          tmLength: '',
          //录像长度
          recFile: '',
          //录像文件名
          recType: '' //录像类型(字段无效)

        }]
      }
    }
  },
  queryRecordNotifyNet: {
    //分页查询通知音记录

    /**通知音查询接口，通知音可用于 组呼通知 操作
    **/
    url: '/scooper-record/data/notify/queryRecordNotify',
    method: 'POST',
    requestParam: {
      token: '',
      title: '',
      //标题
      id: '',
      //通知音记录id
      recTel: '',
      //录制通知音号码
      timeMin: '',
      //开始时间查询起始值
      timeMax: '',
      pageIndex: '',
      pageSize: ''
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        total: '',
        list: [{
          id: 1,
          recTel: '',
          title: '',
          recTm: '',
          //通知音开始录制时间
          callLength: '',
          //通知音录音时长，单位“秒”
          recFile: '' //通知音录音文件名

        }]
      }
    }
  },
  uploadNet: {
    //上传通知音

    /**上传通知音接口，通知音目前只支持格式为wav的语音文件
      通知音可用于 组呼通知 操作
    **/
    url: '/scooper-record/data/notify/upload',
    method: 'POST',
    requestParam: {
      token: '',
      recTel: '',
      //接收号码
      title: '',
      //通知音标题
      recTm: '',
      //通知音录制开始时间 yyyy-MM-dd HH:mm:ss
      callLength: '',
      //通知音录音时长，单位“秒”
      file: '' //通知音文件流

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        id: '' //通知音记录id

      }
    }
  },
  doDownloadNet: {
    //录音录像下载

    /**下载相应类别的录音、录像文件
    **/
    url: '/scooper-record/data/file/doDownload',
    method: 'POST',
    requestParam: {
      token: '',
      id: '',
      //录音/录像id

      /**
       * 0:  通话录音
        1:  通话录像
        10: 会议录音
        11: 会议录像
        20: 通知音
        30：对讲录音
       */
      fileType: '',
      //录音类型
      recFile: '' //录音/录像文件名

    },
    responseParam: {
      file: '' //文件流

    }
  },
  deleteFileNet: {
    //录音录像删除

    /**删除文件记录，同时删除录音或录像文件。
    **/
    url: '/scooper-record/data/file/deleteFile',
    method: 'POST',
    requestParam: {
      token: '',
      id: '',
      //录音/录像id

      /**
       * 0:  通话录音
        1:  通话录像
        10: 会议录音
        11: 会议录像
        20: 通知音
        30：对讲录音
       */
      fileType: '',
      //录音类型
      recFile: '' //录音/录像文件名

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {}
    }
  }
};
export default record;